import { ChangeEvent } from 'react'
import { DataTableProps } from 'ts/interfaces/Components'
import useFetch from 'hooks/useFetch'
import useModalStore from 'store/modal'
import { Card, Error as ErrorMessage, IconButton, SearchInput, Table } from 'components/ui'
import { AddIcon, RefreshIcon } from './svg'

const DataTable = <T extends object>({
  dataKey,
  url,
  columns,
  listName
}: DataTableProps<T>) => {
  const { isLoading, error, tableInstance, refresh } = useFetch(
    dataKey,
    url,
    columns,
    undefined,
    listName
  )

  const openModal = useModalStore((state) => state.openModal)

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.currentTarget
    tableInstance.setGlobalFilter(value || undefined)
  }

  return (
    <div className="p-4 flex justify-center">
      {error ? (
        <div className="flex">
          <ErrorMessage data={error} />
        </div>
      ) : null}

      <Card className="w-max p-3">
        <div className="flex">
          <SearchInput onChange={handleInputChange} />
          <IconButton
            aria-label="add"
            title="add"
            isLoading={isLoading}
            onClick={() => openModal(undefined)}
            className="bg-indigo-500"
          >
            <AddIcon />
          </IconButton>
        </div>

        <Table
          tableInstance={tableInstance}
          isLoading={isLoading}
          onRowClick={openModal}
        />

        <div className="flex justify-end">
          <IconButton
            aria-label="refresh"
            title="refresh"
            isLoading={isLoading}
            onClick={refresh}
            className="bg-gray-200"
          >
            <RefreshIcon />
          </IconButton>
        </div>

      </Card>
    </div>
  )
}

export default DataTable
